import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { tap } from 'rxjs/operators';

export const HEALTH_PROFESSIONAL_EXPORT_URL = 'health-professional-export';

interface ExportProfessionalData {
  name: string;
  cpf: string;
  userId?: string;
}

@Injectable({ providedIn: 'root' })
export class HealthProfessionalExportService {
  constructor(private http: HttpClient) {}

  requestExport(email: string) {
    return this.http.post(`${environment.apiRoot}${HEALTH_PROFESSIONAL_EXPORT_URL}/request`, { email });
  }

  exportProfessionalData({ name, cpf, userId }: ExportProfessionalData) {
    return this.http
      .get(`${environment.apiRoot}${HEALTH_PROFESSIONAL_EXPORT_URL}/${userId}`, {
        observe: 'response',
        responseType: 'blob'
      })
      .pipe(
        tap(response => {
          this.downloadZipFile(response.body, this.generateTimestampedFilename(name));
        })
      );
  }

  private downloadZipFile(zipBlob: Blob, filename: string): void {
    const url = window.URL.createObjectURL(zipBlob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }

  private generateTimestampedFilename(prefix: string = 'dados_exportados'): string {
    const date = new Date()
      .toLocaleDateString('pt-BR')
      .split('/')
      .reverse()
      .join('-');
    return `${prefix}_${date}.zip`;
  }
}
